const API_BASE = process.env.REACT_APP_API_URL || '';
const SERVER_ORIGIN = API_BASE.replace(/\/api\/?$/, '');
const S3_PUBLIC_BASE_URL = (process.env.REACT_APP_S3_PUBLIC_BASE_URL || '').replace(/\/$/, '');

const UPLOADS_PATH_RE = /^\/uploads\//;
const FULL_UPLOADS_URL_RE = /^https?:\/\/[^/]+(\/uploads\/.*)$/i;

export function getS3PublicBaseUrl() {
  return S3_PUBLIC_BASE_URL;
}

export function toStoragePath(url) {
  if (!url) return '';
  const value = String(url).trim();
  if (!value) return value;
  if (UPLOADS_PATH_RE.test(value)) return value;

  if (S3_PUBLIC_BASE_URL && value.startsWith(`${S3_PUBLIC_BASE_URL}/`)) {
    const pathPart = value.slice(S3_PUBLIC_BASE_URL.length);
    if (UPLOADS_PATH_RE.test(pathPart)) return pathPart;
  }

  const match = value.match(FULL_UPLOADS_URL_RE);
  if (match) return match[1];
  return value;
}

/** Resolve relative upload paths to absolute URLs for img src. */
export function resolveAssetUrl(url) {
  if (!url) return '';
  if (url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:')) {
    return url;
  }
  if (UPLOADS_PATH_RE.test(url)) {
    if (S3_PUBLIC_BASE_URL) {
      return `${S3_PUBLIC_BASE_URL}${url}`;
    }
    return `${SERVER_ORIGIN}${url}`;
  }
  return url;
}

export function isServerUploadUrl(url) {
  if (!url || typeof url !== 'string') return false;
  if (url.includes('/uploads/')) return true;
  if (S3_PUBLIC_BASE_URL && url.startsWith(`${S3_PUBLIC_BASE_URL}/uploads/`)) return true;
  return false;
}

export function isManagedAssetUrl(url) {
  return isServerUploadUrl(url);
}
